/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Dictate_HintInputs */



/**
* | output |
* | --- |
* | "Record your voice and we'll transcribe it straight into the message box — you can still edit before sending." |
*
* @param {Chat_Dictate_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_dictate_hint = /** @type {((inputs?: Chat_Dictate_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Dictate_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sprich deine Nachricht ein – wir wandeln sie direkt in Text im Eingabefeld um, den du vor dem Senden noch bearbeiten kannst.")
	return /** @type {LocalizedString} */ ("Record your voice and we'll transcribe it straight into the message box — you can still edit before sending.")
});